export const DEFAULT_ERROR_TITLE = 'Что-то пошло не так';

export const RELOAD_COUNTDOWN_SECONDS = 6;

export type ErrorKind = 'not-found' | 'internal' | 'timeout' | 'unknown';

export type SystemErrorVariant = 'back' | 'reload';

export type SystemErrorProps = {
    imageSrc: string;
    title?: string;
    description: string;
    errorId?: string;
    variant?: SystemErrorVariant;
    onBack?: () => void;
    onReload?: () => void;
    onHome?: () => void;
    countdownSeconds?: number;
};
